import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LANDING_PATH } from '../App';
import { X } from 'lucide-react';

const TermsOfService = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);
        } else {
            navigate(LANDING_PATH, { replace: true });
        }
    };
    return (
        <div className="page-size p-4 md:p-8 relative">
            <button
                className="fixed top-4 right-4 btn btn-outline btn-square btn-sm"
                onClick={handleBack}
            >
                <X />
            </button>
            <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
            <div className="prose max-w-none">
                <h2>Welcome to the official website of Malaysia Fight League (MFL)</h2>
                <p>By accessing and using this website, you agree to be bound by the following terms and conditions. Please read them carefully before using our services or registering for any of our events.</p>
                <h3>1. General</h3>
                <ul>
                    <li>This website is owned and operated by Malaysia Fight League (MFL).</li>
                    <li>MFL reserves the right to change, update, or modify these terms at any time without prior notice.</li>
                    <li>Continued use of the website after changes are made constitutes acceptance of the new terms.</li>
                </ul>
                <h3>2. Website Use</h3>
                <ul>
                    <li>You agree to use this website only for lawful purposes.</li>
                    <li>You must not:
                        <ul>
                            <li>Attempt to gain unauthorized access to the website or any associated systems.</li>
                            <li>Use the site in any way that may disrupt its functionality or security.</li>
                            <li>Distribute malware, spam, or any harmful content.</li>
                        </ul>
                    </li>
                </ul>
                <h3>3. Registration for Events</h3>
                <ul>
                    <li>You certify that all the information provided is accurate and truthful.</li>
                    <li>You acknowledge and accept the <b>risk of injury</b> associated with combat sports.</li>
                    <li>You agree to abide by the rules and regulations of MFL and any relevant sports governing bodies.</li>
                    <li>MFL reserves the right to refuse or cancel registration for any reason, including misconduct or violation of event rules.</li>
                </ul>
                <p>Please refer to our <b>Return & Refund Policy</b> for detailed terms on event cancellations, opponent matching, and credit/refund procedures.</p>
                <h3>4. Media Consent</h3>
                <ul>
                    <li>By attending or participating in any MFL event, you grant us the right to use your image, likeness, name, or voice in any photos, videos, or promotional materials, in any media, worldwide, in perpetuity.</li>
                    <li>MFL owns the rights to all event footage and photography captured by its crew or designated media partners.</li>
                </ul>
                <h3>5. Pay-Per-View (PPV) Content</h3>
                <ul>
                    <li>All PPV purchases are subject to the Return & Refund Policy.</li>
                    <li>Content is licensed for personal use only and may not be recorded, redistributed, or broadcasted without written permission.</li>
                    <li>One PPV purchase is valid for use on one device only.</li>
                </ul>
                <h3>6. Intellectual Property</h3>
                <ul>
                    <li>All content on this website — including logos, designs, graphics, videos, and written content — is the property of MFL or its content creators and is protected by copyright and intellectual property laws.</li>
                    <li>You may not use, copy, or reproduce any content without prior written consent.</li>
                </ul>
                <h3>7. Limitation of Liability</h3>
                <ul>
                    <li>MFL is not liable for:
                        <ul>
                            <li>Any personal injuries, damages, or losses sustained before, during, or after an event.</li>
                            <li>Technical difficulties or failures during PPV streaming beyond our control.</li>
                            <li>Incorrect or unauthorized use of this website or services.</li>
                        </ul>
                    </li>
                </ul>
                <h3>8. Privacy Policy</h3>
                <ul>
                    <li>We collect and store personal data for registration, communication, and service improvement purposes.</li>
                    <li>We do not sell or share your data with third parties except where necessary to deliver services or comply with legal obligations.</li>
                    <li>For more details, please refer to our Privacy Policy.</li>
                </ul>
                <h3>9. Governing Law</h3>
                <p>These terms are governed by the laws of <b>Malaysia</b>. Any disputes arising out of the use of this site or MFL services shall be resolved in Malaysian courts.</p>
                <h3>10. Contact Information</h3>
                <p>For any questions about these Terms and Conditions, please contact us:<br />
                    <b>info@malaysiafightleague.com</b><br />
                    <b>+60 10-983 1808</b><br />
                    <a href="http://www.malaysiafightleague.com" target="_blank" rel="noopener noreferrer">www.malaysiafightleague.com</a></p>
            </div>
        </div>
    );
};

export default TermsOfService; 